import React, { useState, useEffect } from 'react';
import { useTheme } from '../../context/ThemeContext';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';

const AuthModal = ({ isOpen, onClose, initialView = 'login' }) => {
  const { isDark } = useTheme();
  const [currentView, setCurrentView] = useState(initialView);

  // Reset view when modal opens with new initialView
  useEffect(() => {
    if (isOpen) {
      setCurrentView(initialView);
    }
  }, [isOpen, initialView]);

  const handleSwitchToLogin = () => {
    setCurrentView('login');
  };

  const handleSwitchToRegister = () => {
    setCurrentView('register');
  };

  const handleAuthSuccess = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 backdrop-blur-sm flex items-center justify-center p-4 z-50 animate-fade-in-scale">
      <div className="relative max-w-md w-full">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 glass-dark rounded-full p-3 hover:scale-110 transform transition-all duration-300 z-10 group"
        >
          <svg
            className={`w-5 h-5 transition-colors ${isDark ? 'text-gray-300 group-hover:text-white' : 'text-gray-600 group-hover:text-gray-800'}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        {/* Modal Content */}
        <div className="glass-modal rounded-2xl p-8 animate-slide-in-up">
          {/* Header */}
          <div className="text-center mb-8">
            <h1 className={`heading-mono text-hierarchy-2 text-glow mb-2 ${isDark ? 'text-white' : 'text-gray-800'}`}>
              {currentView === 'login' ? 'Welcome Back' : 'Join Eyehill AEO'}
            </h1>
            <p className={`text-mono ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
              {currentView === 'login' 
                ? 'Sign in to your account' 
                : 'Create your account to get started'
              }
            </p>
          </div>

          {/* Form content */}
          {currentView === 'login' ? (
            <LoginForm
              onSwitchToRegister={handleSwitchToRegister}
              onLoginSuccess={handleAuthSuccess}
            />
          ) : (
            <RegisterForm
              onSwitchToLogin={handleSwitchToLogin}
              onRegisterSuccess={handleAuthSuccess}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthModal;